import enumeration from "./enumeration";

const PaymentType = {
  Full: "FULL",
  Split: "SPLIT",
};

export default enumeration(PaymentType);
